import client from './client'

export default {
  Reminder: authInfo => client.post('/api/reminder', authInfo)
}
